export default __webpack_public_path__ + "static/media/777.ec20c389.png";